export const UPDATE_QUANTITY = "UPDATE_QUANTITY"
export const UPDATE_ORDERS = "UPDATE_ORDERS"
export const SET_USER_LABEL_LIMIT = "SET_USER_LABEL_LIMIT"
export const UPDATE_CURRENT_ORDER = "UPDATE_CURRENT_ORDER"
export const RESET_CURRENT_ORDER = "RESET_CURRENT_ORDER"
